/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_SubtitleInputs */

const vi_shop_contact_subtitle = /** @type {(inputs: Shop_Contact_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin liên hệ của cửa hàng.`)
};

/**

* @param {Shop_Contact_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_subtitle = /** @type {((inputs?: Shop_Contact_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_subtitle(inputs)
});